(() => {
  const selector = '.jct-hero, .jct-contact, .jct-media';

  const reveal = (root = document) => {
    const sections = [...root.querySelectorAll(selector)];
    if (!sections.length) return;

    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    sections.forEach((section) => observer.observe(section));
  };

  const forms = (root = document) => {
    root.querySelectorAll('.jct-form:not([data-jct-ready])').forEach((form) => {
      form.dataset.jctReady = 'true';
      form.addEventListener('submit', () => {
        const button = form.querySelector('button[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');
      }, { once: true });
    });
  };

  const init = (root = document) => {
    reveal(root);
    forms(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
